<template>
  <div>
    <div class="card-header">
      <ul class="nav nav-tabs card-header-tabs" name="locale">
        <li class="nav-item locale-tab" v-for="locale in locales" :key="locale">
          <a class="nav-link" :class="{active: openTab===locale}" :id="`message-${locale}-tab`" @click="setOpenTab(locale)" :href="`#message-${locale}`" role="tab" :aria-controls="`message-${locale}`" :aria-selected="openTab===locale">
            <span v-text="$t(`js.backend.message_local_content.languages.${locale}`)"></span>
            <a v-if="openTab === locale" @click.stop.prevent="removeLocale(locale)" class="ml-2 mr-n2 text-danger fas fa-times-circle" href="#"><span class="sr-only" v-text="$t('js.backend.message_local_content.remove_language')"></span></a>
          </a>
        </li>
        <li class="nav-item" v-if="unusedLocales.length > 0" :key="'new'">
          <a class="nav-link" :class="{active: openTab==='new'}" :id="`message-new-tab`" @click.prevent="setOpenTab('new')" :href="`#message-new`" role="tab" :aria-controls="`message-new`" :aria-selected="openTab==='new'">
            <i class="fa fa-plus"></i>
          </a>
        </li>
      </ul>
    </div>
    <div class="card-body">
      <div class="tab-content">
        <div v-for="locale in locales" class="tab-pane fade" :class="{show: openTab===locale, active: openTab===locale}" :key="`message-${locale}`" :id="`message-${locale}`" role="tabpanel" :aria-labelledby="`message-${locale}-tab`">
          <label :for="`message_subject_${locale}`">{{ $t('js.backend.message_local_content.subject') }}</label>
          <div class="form-group">
            <label class="sr-only" :for="`message_subject_${locale}`">{{ locale }}</label>
            <input :lang="locale" v-model="subject[locale]" class="form-control" type="text" :name="`message[subject][${locale}]`" :id="`message_subject_${locale}`">
            <input type="hidden" :value="locale" name="message[locales][]">
          </div>
          <Trumbowyg v-model="content[locale]" :config="wysiwygConfig" :lang="locale" :name="`message[content][${locale}]`"></Trumbowyg>
        </div>
        <div class="tab-pane fade" :class="{show: openTab==='new', active: openTab==='new'}" :id="`message-new`" role="tabpanel" :aria-labelledby="`message-new-tab`">
          <label class="form-group">
            {{$t('js.backend.message_local_content.add_language')}}
            <select class="form-control" @change="addLocaleChangeHandler">
              <option selected value="blank">{{$t('js.backend.message_local_content.select_one')}}</option>
              <option v-for="locale in unusedLocales" :value="locale">{{$t(`js.backend.message_local_content.languages.${locale}`)}}</option>
            </select>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Trumbowyg from '../../shared/trumbowyg/Trumbowyg'
import wysiwygConfig from '../../../packs/backend/wysiwyg'
export default {
  components: {
    Trumbowyg
  },
  name: "MessageLocalContent",
  props: {
    currentLocale: {
      type: String,
      default() {
        return this.$i18n.locale
      }
    },
    locales: {
      type: Array,
      default() {
        return [this.$i18n.locale];
      }
    },
    subject: {
      type: Object,
      default() {
        return {[this.currentLocale]: ''};
      }
    },
    content: {
      type: Object,
      default() {
        return {[this.currentLocale]: ''};
      }
    },
    availableLocales: {
      type: Array,
      default() {
        return this.$i18n.availableLocales
      }
    }
  },
  data() {
    return {
      openTab: this.locales.includes(this.currentLocale) ? this.currentLocale : this.locales[0] || 'new',
      wysiwygConfig
    }
  },
  computed:{
    unusedLocales(){
      return this.availableLocales.filter(locale => !this.locales.includes(locale))
    }
  },
  methods:{
    setOpenTab(locale){
      this.openTab = locale
    },
    addLocaleChangeHandler(event){
      let selectedOption = event.target.selectedOptions[0];
      if(selectedOption && selectedOption.value !== 'blank'){
        this.addLocale(selectedOption.value)
      }
      event.target.selectedIndex = 0
    },
    addLocale(locale){
      if(!this.locales.includes(locale)){
        this.locales.push(locale);
      }
      this.setOpenTab(locale)
    },
    removeLocale(locale){
      let index = this.locales.indexOf(locale)
      if(index >= 0){
        this.locales.splice(index, 1);
      }
      this.setOpenTab(this.locales[Math.max(index-1, 0)] || 'new')
    }
  }
}
</script>